// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1FhNo","colCheckbox":"styles_colCheckbox__1Zkui"};